const inspectionList = {
  backbtn: "Go Back",
  inspectionList: "Inspection List",
  search: "Search",
  equipmentTag: "Asset Tag",
  customer: "Customer",
  inspectionDate: "Inspection Date",
  zone: "Zone"
};
export default inspectionList;
